import _defineProperty from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/defineProperty";
import classnames from 'classnames2';
import React from 'react';
import { SwitchIndicatorSVG } from './SwitchIndicatorSVG';
import styles from './Switch.scss';

function createSwitch(displayName, labelSizeStyle) {
  var SwitchComponent = function SwitchComponent(props) {
    var _classnames, _classnames2, _classnames4, _classnames5, _classnames6;

    var containerStyles = classnames((_classnames = {}, _defineProperty(_classnames, styles.container, true), _defineProperty(_classnames, labelSizeStyle, true), _classnames));
    var labelStyles = classnames((_classnames2 = {}, _defineProperty(_classnames2, styles.label, true), _defineProperty(_classnames2, labelSizeStyle, true), _defineProperty(_classnames2, styles.labelSelected, props.checked), _defineProperty(_classnames2, styles.labelDisabled, props.disabled), _classnames2));

    var statusStyles = function statusStyles(statusStateStyle) {
      var _classnames3;

      return classnames((_classnames3 = {}, _defineProperty(_classnames3, styles.status, true), _defineProperty(_classnames3, statusStateStyle, true), _defineProperty(_classnames3, styles.statusSelected, props.checked), _defineProperty(_classnames3, styles.statusDisabled, props.disabled), _classnames3));
    };

    var svgTrackStyles = classnames((_classnames4 = {}, _defineProperty(_classnames4, styles.track, true), _defineProperty(_classnames4, styles.trackSelected, props.checked), _defineProperty(_classnames4, styles.trackDisabled, props.disabled), _classnames4));
    var svgKnobContainerStyles = classnames((_classnames5 = {}, _defineProperty(_classnames5, styles.knobContainer, true), _defineProperty(_classnames5, styles.knobContainerSelected, props.checked), _defineProperty(_classnames5, styles.knobContainerDisabled, props.disabled), _classnames5));
    var svgKnobStyles = classnames((_classnames6 = {}, _defineProperty(_classnames6, styles.knob, true), _defineProperty(_classnames6, styles.knobSelected, props.checked), _defineProperty(_classnames6, styles.knobDisabled, props.disabled), _classnames6));
    return React.createElement("div", {
      className: containerStyles,
      "data-test": props.dataTest
    }, props.label && React.createElement("label", {
      htmlFor: props.id,
      className: labelStyles
    }, props.label), React.createElement("div", {
      className: styles.inputContainer
    }, React.createElement("input", {
      id: props.id,
      type: "checkbox",
      className: styles.input,
      disabled: props.disabled,
      checked: props.checked,
      onChange: function onChange() {
        return props.onChange && props.onChange();
      },
      "aria-checked": props.checked
    }), React.createElement("span", {
      className: statusStyles(styles.statusOff),
      "data-test": "label-off"
    }, props.labelOff), React.createElement(SwitchIndicatorSVG, {
      containerClassName: styles.indicatorContainer,
      svgContainerClassName: styles.indicator,
      trackClassName: svgTrackStyles,
      knobContainerClassName: svgKnobContainerStyles,
      knobClassName: svgKnobStyles
    }), React.createElement("span", {
      className: statusStyles(styles.statusOn),
      "data-test": "label-on"
    }, props.labelOn)));
  };

  SwitchComponent.defaultProps = {
    labelOn: 'on',
    labelOff: 'off'
  };
  SwitchComponent.displayName = displayName;
  return SwitchComponent;
}

var DefaultSwitch = createSwitch('Switch.Default', styles.defaultSize);
export var Switch = Object.assign(DefaultSwitch, {
  Default: DefaultSwitch,
  Small: createSwitch('Switch.Small', styles.smallSize)
});